import React from "react";
import { motion, AnimatePresence } from "framer-motion";



import { Link } from "react-router-dom";


import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
const processData = {
  mechanical: [
    { num: "01", title: "Requirement Gathering", desc: "Understanding goals and technical requirements." },
    { num: "02", title: "Concept Design", desc: "Creating and evaluating initial design concepts." },
    { num: "03", title: "Detailed CAD", desc: "Building precise 3D CAD engineering models." },
    { num: "04", title: "Prototyping", desc: "Developing and testing physical prototypes." },
    { num: "05", title: "Design for Manufacture", desc: "Optimizing design for manufacturing processes." },
    { num: "06", title: "Manufacturer Sourcing", desc: "Selecting suppliers and production partners." },
  ],
  electrical: [
    { num: "01", title: "Requirement Gathering", desc: "Defining electrical system requirements." },
    { num: "02", title: "Component Selection", desc: "Choosing optimized electronic components." },
    { num: "03", title: "Research & Development", desc: "Testing concepts and validating solutions." },
    { num: "04", title: "PCB Design", desc: "Designing schematics and PCB layouts." },
    { num: "05", title: "Prototyping", desc: "Fabricating and validating prototype boards." },
    { num: "06", title: "Assembly & Source Code", desc: "Assembly, firmware integration, and testing." },
  ],
};

function Process() {
  const [activeTab, setActiveTab] = React.useState("mechanical");
  const [activeStep, setActiveStep] = React.useState(0);
  const [hoveredStep, setHoveredStep] = React.useState(null);
  const currentProcess = processData[activeTab];

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (activeStep < 5) {
        setActiveStep((p) => p + 1);
      } else {
        setActiveTab((t) => (t === "mechanical" ? "electrical" : "mechanical"));
        setActiveStep(0);
      }
    }, 2000);
    return () => clearTimeout(timer);
  }, [activeStep, activeTab]);

  return (
    <section className="py-12 sm:py-16 lg:py-20 xl:py-24 bg-white overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 xl:px-12">

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12 sm:mb-16"
        >
          <button className="border border-[#e5e5e5] text-[11px] tracking-wide uppercase px-5 py-2 rounded-full text-[#666] font-medium mb-5 sm:mb-7">
            Our Process
          </button>
          <h2 className="text-[clamp(32px,5vw,72px)] font-bold leading-tight text-[#111]">
            From <span className="text-[#c021d6]">Idea</span> To Execution
          </h2>
        </motion.div>

        {/* Tab Toggle */}
        <div className="flex justify-center mb-16 sm:mb-20 lg:mb-24">
          <div className="bg-white rounded-full p-1.5 sm:p-2 shadow-lg flex gap-1 sm:gap-2">
            {["mechanical", "electrical"].map((tab) => (
              <button
                key={tab}
                onClick={() => { setActiveTab(tab); setActiveStep(0); }}
                className={`px-4 sm:px-6 lg:px-8 py-2.5 sm:py-3 rounded-full text-xs sm:text-sm lg:text-base font-semibold transition-all duration-300 ${activeTab === tab
                    ? "bg-gradient-to-r from-[#ff2ec4] to-[#6d2ca0] text-white shadow-md"
                    : "text-[#666]"
                  }`}
              >
                {tab === "mechanical" ? "Mechanical Process" : "Electrical Process"}
              </button>
            ))}
          </div>
        </div>

        {/* Steps */}
        <div className="relative">
          <div className="hidden lg:block absolute top-10 left-0 w-full h-[2px] bg-gray-100" />
          <motion.div
            animate={{ width: `${(activeStep / 5) * 100}%` }}
            transition={{ duration: 0.5 }}
            className="hidden lg:block absolute top-10 left-0 h-[2px] bg-gradient-to-r from-[#ff2ec4] to-[#6d2ca0]"
          />

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6 sm:gap-8 lg:gap-6 xl:gap-10 relative z-10">
            {currentProcess.map((step, i) => {
              const isActive = activeStep === i;
              const isHov = hoveredStep === i;
              return (
                <motion.div
                  key={step.num}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  viewport={{ once: true }}
                  onMouseEnter={() => setHoveredStep(i)}
                  onMouseLeave={() => setHoveredStep(null)}
                  className="relative flex flex-col items-center text-center cursor-pointer"
                >
                  <AnimatePresence>
                    {(isHov || isActive) && (
                      <motion.div
                        initial={{ opacity: 0, y: 10, scale: 0.92 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 10, scale: 0.92 }}
                        transition={{ duration: 0.25 }}
                        className={`absolute z-20 w-[160px] sm:w-[190px] lg:w-[210px] ${i % 2 === 0 ? "-top-24 sm:-top-28" : "top-[110px] sm:top-[125px]"
                          }`}
                      >
                        <div className="relative bg-[#ffd4df] border border-[#f3aabb] rounded-2xl px-3 sm:px-4 py-2.5 sm:py-3 shadow-xl">
                          <p className="text-[#7a4450] text-[11px] sm:text-[13px] leading-relaxed font-medium">
                            {step.desc}
                          </p>
                          <div
                            className={`absolute left-1/2 -translate-x-1/2 w-3 h-3 sm:w-4 sm:h-4 bg-[#ffd4df] border-[#f3aabb] rotate-45 ${i % 2 === 0 ? "-bottom-1.5 sm:-bottom-2 border-r border-b" : "-top-1.5 sm:-top-2 border-l border-t"
                              }`}
                          />
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>

                  <motion.div
                    animate={{ scale: isActive || isHov ? 1.18 : 1 }}
                    transition={{ duration: 0.3 }}
                    className={`w-4 h-4 sm:w-5 sm:h-5 rounded-full mb-4 sm:mb-6 border-[4px] sm:border-[5px] transition-all duration-300 ${isActive || isHov
                        ? "bg-[#c021d6] border-[#f5c9ff] shadow-[0_0_25px_rgba(192,33,214,0.45)]"
                        : "bg-white border-[#d7b5e8]"
                      }`}
                  />
                  <h3
                    className={`text-[38px] sm:text-[52px] lg:text-[58px] xl:text-[68px] font-black leading-none transition-all duration-300 ${isActive || isHov ? "text-[#c021d6]" : "text-[#c021d6]/20"
                      }`}
                  >
                    {step.num}
                  </h3>
                  <p
                    className={`mt-2 sm:mt-3 text-[13px] sm:text-[15px] lg:text-base font-medium transition-all duration-300 ${isActive || isHov ? "text-[#111]" : "text-[#666]"
                      }`}
                  >
                    {step.title}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
export default Process;